import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components/native';
import { Title } from '@sp/ui/typography';
import { Button } from '@sp/ui/base/buttons';

import { getColorByType } from './index.shared';

const BUTTON_MARGIN_TOP = 10;

const Wrapper = styled.View`
  margin: 0 ${(props) => (props.disableMargin ? 0 : props.theme.SPACINGS.md)}px;
  padding: ${(props) => props.theme.SPACINGS.md}px;
  border-radius: ${(props) => props.theme.DEFAULTS.BORDER_RADIUS}px;
  ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor}` : '')};
  ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor}` : '')};
`;

const TitleWrapper = styled.View`
  padding-bottom: ${(props) => props.theme.SPACINGS.md}px;
`;

const ButtonWrapper = styled.View`
  margin-top: ${BUTTON_MARGIN_TOP}px;
  align-items: center;
`;

const Card = ({ type, children, title, theme, buttons, buttonComponent, disableMargin }) => (
  <Wrapper
    backgroundColor={getColorByType(type, theme).backgroundColor}
    borderColor={getColorByType(type, theme).borderColor}
    disableMargin={disableMargin}
  >
    {title && (
      <TitleWrapper>
        <Title textAlign="center" fontWeight="bold">
          {title}
        </Title>
      </TitleWrapper>
    )}
    {children}
    {buttonComponent ||
      (buttons &&
        buttons.map((button) => (
          <ButtonWrapper key={button.text}>
            <Button size="medium" {...button} />
          </ButtonWrapper>
        )))}
  </Wrapper>
);

Card.propTypes = {
  type: PropTypes.oneOf(['warning', 'error', 'info']),
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  title: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.oneOf(['primary', 'secondary', 'destructive']),
      onPress: PropTypes.func,
      inactive: PropTypes.bool,
    })
  ),
  buttonComponent: PropTypes.node,
  disableMargin: PropTypes.bool,
};

Card.defaultProps = {
  type: 'info',
  title: undefined,
  buttons: undefined,
  buttonComponent: undefined,
  disableMargin: false,
};

export default withTheme(Card);
